import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../store/authStore';
import { http } from '@/network/http';
import { BaseModal } from '@/components/modal/BaseModal';

export function TermsAcceptanceModal() {
  const { t } = useTranslation();
  const user = useAuthStore((s) => s.user);
  const setUser = useAuthStore((s) => s.setUser);
  const [loading, setLoading] = useState(false);

  // Show only for authenticated users who haven't accepted terms
  if (!user || user.termsAcceptedAt) return null;

  const handleAccept = async () => {
    try {
      setLoading(true);
      const res = await http.post('/users/me/accept-terms');
      if (res.data?.success) {
        setUser({ ...user, termsAcceptedAt: res.data.termsAcceptedAt || new Date().toISOString() });
      }
    } catch (err) {
      console.error('Failed to accept terms:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <BaseModal isOpen={true} onClose={() => {}} flushTop ariaLabel={t('terms.title')}>
      <div className="flex flex-col h-full">
        <div className="px-5 pt-5 pb-3">
          <h2 className="text-lg font-bold text-neutral-800">{t('terms.title')}</h2>
          <p className="mt-1 text-sm text-neutral-500">{t('terms.subtitle')}</p>
        </div>

        <div className="flex-1 overflow-y-auto px-5 pb-4" style={{ overscrollBehaviorY: 'contain', touchAction: 'pan-y' }} onPointerDownCapture={(e) => e.stopPropagation()}>
          <div className="rounded-xl bg-neutral-50 p-4 text-sm text-neutral-700 leading-relaxed">
            <h3 className="font-bold mb-2">{t('terms.eulaTitle')}</h3>
            <p className="mb-3">{t('terms.eulaIntro')}</p>

            <h4 className="font-semibold mt-3 mb-1">{t('terms.conductTitle')}</h4>
            <ul className="list-disc ps-5 space-y-1">
              <li>{t('terms.conductRule1')}</li>
              <li>{t('terms.conductRule2')}</li>
              <li>{t('terms.conductRule3')}</li>
              <li>{t('terms.conductRule4')}</li>
            </ul>

            <h4 className="font-semibold mt-3 mb-1">{t('terms.moderationTitle')}</h4>
            <p>{t('terms.moderationText')}</p>

            <h4 className="font-semibold mt-3 mb-1">{t('terms.terminationTitle')}</h4>
            <p>{t('terms.terminationText')}</p>
          </div>
        </div>

        <div className="px-5 py-4 flex-shrink-0">
          <button
            type="button"
            onClick={handleAccept}
            disabled={loading}
            className="w-full rounded-xl py-3 text-sm font-bold text-white transition-all active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
            style={{
              background: 'linear-gradient(135deg, #1a4fa0 0%, #3b8dd4 100%)',
            }}
          >
            {loading ? '...' : t('terms.accept')}
          </button>
        </div>
      </div>
    </BaseModal>
  );
}
